import React from 'react';
import { CofidisCaseList } from './CofidisCaseList';

// Hipotecas comparte el detalle de casos bancarios, pero su lista consulta
// únicamente los formularios que llegan desde el portal hipotecario.
export const HipotecasCaseList = (props) => (
  <CofidisCaseList {...props} bankGroup="HIPOTECAS" />
);
